module.exports = __webpack_public_path__ + "static/media/background.e413977e.jpg";